import { Navigate, Outlet } from 'react-router-dom'
import { useAuth } from '@/hooks/useAuth'
import { usePlan } from '@/hooks/usePlan'
import { TrialExpiredPaywall } from '@/components/TrialExpiredPaywall'
import { Loader2 } from 'lucide-react'

export function ProtectedRoute() {
  const { user, loading: authLoading } = useAuth()
  const { isPro, isTrial, isTrialExpired, isLoading: planLoading } = usePlan()

  // 1. Verificando autenticação
  if (authLoading) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-muted/30">
        <div className="flex flex-col items-center gap-3">
          <Loader2 className="h-8 w-8 animate-spin text-primary" />
          <p className="text-sm text-muted-foreground">Carregando...</p>
        </div>
      </div>
    )
  }

  // 2. Não autenticado → login
  if (!user) {
    return <Navigate to="/login" replace />
  }

  // 3. Verificando status do plano
  if (planLoading) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-muted/30">
        <div className="flex flex-col items-center gap-3">
          <Loader2 className="h-8 w-8 animate-spin text-primary" />
          <p className="text-sm text-muted-foreground">Verificando plano...</p>
        </div>
      </div>
    )
  }

  // 4. Trial expirado e não é Pro → Paywall
  if (isTrialExpired && !isPro) {
    return <TrialExpiredPaywall />
  }

  // 5. Acesso liberado (Pro ou Trial ativo)
  return <Outlet />
}
